export default __webpack_public_path__ + "static/comprehensive_admin_overview-5f13a1654fa71b20b48d19a64294e627.svg";